const SERIALIZED_AGENCY_TYPES = {
  BUS: 1,
  TRUCK: 2,
};

const OPTION_TYPES = {
  AGENCY: 'agency',
  SIMPLE: 'simple',
  SPECIAL: 'special',
};

export {
  SERIALIZED_AGENCY_TYPES,
  OPTION_TYPES,
};



// WEBPACK FOOTER //
// ./src/helpers/ShippingOptionHelper.js